import * as React from 'react'

function GooglePlayIcon({ width = 69, height = 16, color = '#50A7FF', ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox="0 0 69 16" fill="none" {...props}>
      <g clipPath="url(#prefix__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.73 9.496c0-2.202 1.847-3.996 4.044-3.996 1.214 0 2.079.478 2.73 1.101l-.767.77a2.77 2.77 0 00-1.964-.78c-1.604 0-2.858 1.296-2.858 2.905 0 1.608 1.254 2.905 2.857 2.905 1.04 0 1.632-.418 2.012-.8.31-.312.515-.76.593-1.374h-2.603v-1.09h3.665c.038.196.058.43.058.682 0 .818-.224 1.832-.944 2.554-.7.732-1.594 1.122-2.78 1.122-2.198 0-4.044-1.792-4.044-3.997l.001-.002zm10.73-1.15c-1.42 0-2.578 1.083-2.578 2.573 0 1.483 1.158 2.573 2.578 2.573s2.575-1.092 2.575-2.574c0-1.49-1.156-2.572-2.575-2.571zm0 4.134c-.777 0-1.449-.643-1.449-1.56 0-.926.67-1.56 1.449-1.56.777 0 1.447.633 1.447 1.56 0 .916-.67 1.56-1.447 1.56zm5.62-4.133c-1.42 0-2.576 1.082-2.576 2.572 0 1.483 1.157 2.573 2.576 2.573 1.42 0 2.576-1.092 2.576-2.574 0-1.49-1.156-2.572-2.576-2.571zm0 4.133c-.777 0-1.448-.643-1.448-1.56 0-.926.67-1.56 1.448-1.56.777 0 1.448.633 1.448 1.56 0 .916-.671 1.56-1.448 1.56zm6.898-3.977v.419h-.039c-.252-.304-.738-.576-1.35-.576-1.283 0-2.461 1.131-2.461 2.584 0 1.442 1.177 2.564 2.46 2.564.613 0 1.099-.273 1.351-.584h.039v.37c0 .984-.525 1.51-1.37 1.51-.691 0-1.119-.497-1.294-.915l-.983.41c.282.681 1.031 1.52 2.275 1.52 1.322 0 2.44-.78 2.44-2.681V8.502l-1.068.001zm-1.293 3.977c-.777 0-1.43-.654-1.43-1.55 0-.906.652-1.569 1.43-1.569.768 0 1.37.662 1.37 1.57.002.895-.601 1.55-1.37 1.55zm3.14-6.707h1.128v7.564h-1.129V5.773zm4.22 6.707c-.573 0-.983-.264-1.243-.779l3.432-1.425-.119-.292c-.212-.574-.865-1.637-2.197-1.637-1.322 0-2.42 1.043-2.42 2.573 0 1.442 1.088 2.573 2.547 2.573 1.177 0 1.858-.72 2.14-1.14l-.876-.585c-.292.43-.691.713-1.264.712zm-.088-3.14c.447 0 .826.225.952.546l-2.295.956c-.028-.994.769-1.501 1.343-1.501zm7.227-3.567h-2.697v7.564h1.125v-2.865h1.573c1.248 0 2.475-.906 2.475-2.35 0-1.441-1.226-2.348-2.473-2.348h-.003zm.03 3.646h-1.602V6.825h1.602c.841 0 1.32.7 1.32 1.297 0 .587-.479 1.297-1.32 1.297zm4.192 3.918V5.773h-1.125v7.564h1.125zm5.058-.013v-2.9c0-1.343-1.001-2.092-2.293-2.092-.814 0-1.658.36-2.008 1.159l1 .417c.213-.417.61-.554 1.029-.554.582 0 1.173.35 1.183.974v.078a2.48 2.48 0 00-1.175-.293c-1.077 0-2.173.594-2.173 1.703 0 1.013.883 1.664 1.873 1.664.758 0 1.175-.34 1.436-.739h.039v.585h1.088v-.002zm-2.427-.846c-.369 0-.884-.184-.884-.64 0-.585.642-.81 1.195-.81.495 0 .727.106 1.03.253a1.37 1.37 0 01-1.341 1.197zm6.386-3.98l-1.291 3.279h-.039l-1.34-3.279h-1.212l2.008 4.584-1.146 2.549h1.174l3.096-7.133h-1.25z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.605 1.214c-.157.17-.248.43-.248.768v12.034c0 .338.09.598.253.762l.043.036L8.378 8.07v-.152l-6.73-6.74-.043.035z"
          fill="url(#prefix__b)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.615 10.327l-2.243-2.25V7.92l2.244-2.25.048.03 2.654 1.513c.76.43.76 1.137 0 1.572l-2.654 1.512-.049.03z"
          fill="url(#prefix__c)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.663 10.297L8.372 8l-6.768 6.785c.248.267.663.297 1.128.036l7.931-4.523z"
          fill="url(#prefix__d)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.663 5.702l-7.93-4.517c-.465-.267-.881-.23-1.129.036l6.767 6.778 2.292-2.297z"
          fill="url(#prefix__e)"
        />
        <path
          opacity={0.2}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.615 10.249L2.74 14.736c-.44.254-.833.236-1.086.006l-.042.043.042.036c.253.23.646.248 1.086-.006l7.93-4.517-.054-.049z"
          fill="#000"
        />
        <path
          opacity={0.12}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.317 8.707l-2.708 1.542.049.048 2.654-1.512c.38-.217.567-.501.567-.786-.025.26-.218.508-.562.708z"
          fill="#000"
        />
        <path
          opacity={0.25}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.733 1.263l10.584 6.03c.344.193.537.447.567.707 0-.284-.187-.568-.567-.786L2.733 1.184c-.76-.435-1.376-.072-1.376.799v.078c0-.87.616-1.227 1.376-.798z"
          fill="#fff"
        />
        <path
          d="M21.305 2.355c0 .5-.148.898-.445 1.195-.333.353-.771.53-1.314.53-.52 0-.96-.18-1.32-.54-.36-.36-.54-.803-.54-1.33s.18-.97.54-1.33c.36-.36.8-.54 1.32-.54.263 0 .511.047.745.14.233.093.424.225.575.395l-.33.33a1.084 1.084 0 00-.43-.31 1.369 1.369 0 00-.56-.115c-.39 0-.72.135-.99.405-.267.273-.4.615-.4 1.025 0 .41.133.752.4 1.025.27.27.6.405.99.405.356 0 .653-.1.89-.3.236-.2.373-.475.41-.825h-1.3v-.43h1.735c.016.093.024.183.024.27zM23.954.42v.44h-1.63v1.135h1.47v.43h-1.47V3.56h1.63V4h-2.09V.42h2.09zm1.84.44V4h-.46V.86h-1V.42h2.46v.44h-1zM28.833 4h-.46V.42h.46V4zM30.775.86V4h-.46V.86h-1V.42h2.46v.44h-1zm5.986 1.35c0 .53-.177.973-.53 1.33-.357.36-.793.54-1.31.54-.52 0-.957-.18-1.31-.54-.353-.357-.53-.8-.53-1.33s.177-.973.53-1.33c.353-.36.79-.54 1.31-.54s.957.182 1.31.545c.353.357.53.798.53 1.325zm-3.21 0c0 .413.13.755.39 1.025.263.27.59.405.98.405s.715-.135.975-.405c.263-.267.395-.608.395-1.025 0-.417-.132-.758-.395-1.025a1.298 1.298 0 00-.975-.405c-.39 0-.717.135-.98.405-.26.27-.39.612-.39 1.025zM37.764 4h-.46V.42h.56l1.74 2.785h.02l-.02-.69V.42h.46V4h-.48l-1.82-2.92h-.02l.02.69V4z"
          fill={color}
        />
      </g>
      <defs>
        <linearGradient id="prefix__b" x1={7.77} y1={1.857} x2={-2.995} y2={4.716} gradientUnits="userSpaceOnUse">
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient id="prefix__c" x1={14.307} y1={7.997} x2={1.173} y2={7.997} gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient id="prefix__d" x1={9.418} y1={9.247} x2={0.728} y2={23.818} gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient id="prefix__e" x1={-0.101} y1={-2.793} x2={3.777} y2={3.71} gradientUnits="userSpaceOnUse">
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
        <clipPath id="prefix__a">
          <path fill="#fff" transform="translate(.463)" d="M0 0h68.21v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default React.memo(GooglePlayIcon)
